import axios from "axios";

const onlineFormsBaseUrl = process.env.VUE_APP_API_URL_ONLINE_FORMS;
const banquetInquiryBaseUrl = `${onlineFormsBaseUrl}banquetinquiry`;
const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

export default {
  healthCheck() {
    return httpClient.get(onlineFormsBaseUrl);
  },
  createBanquetInquiry(payload) {
    return httpClient.post(`${banquetInquiryBaseUrl}/create`, payload);
  }
};
